import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface GoodsServiceDto {
	id: string;
	worldId: string;
	name: string;
	category: string | null;
	description: string | null;
	gmNotes: string | null;
	cost: string | null;
	currency: string | null;
	availability: string | null;
	imageAssetId: string | null;
	sourcePoiId: string | null;
	sourcePoiName: string | null;
	sourceRegionName: string | null;
	foundryId: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface GoodsServicesListResponse {
	goods: GoodsServiceDto[];
	total: number;
}

export interface GoodsServiceGetResponse {
	goods: GoodsServiceDto;
}

export interface UpsertGoodsServiceRequest {
	name: string;
	category?: string | null;
	description?: string | null;
	gmNotes?: string | null;
	cost?: string | null;
	currency?: string | null;
	availability?: string | null;
	imageAssetId?: string | null;
	sourcePoiId?: string | null;
	foundryId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class GoodsServicesService {
	constructor(private readonly http: HttpClient) {}

	list(
		worldId: string,
		args?: { q?: string; regionId?: string; poiId?: string; limit?: number }
	): Observable<GoodsServicesListResponse> {
		let params = new HttpParams().set('format', 'list');
		if (args?.q) params = params.set('q', args.q);
		if (args?.regionId) params = params.set('regionId', args.regionId);
		if (args?.poiId) params = params.set('poiId', args.poiId);
		if (args?.limit) params = params.set('limit', String(args.limit));
		return this.http.get<GoodsServicesListResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/goods-services`, { params });
	}

	get(worldId: string, goodsId: string): Observable<GoodsServiceGetResponse> {
		return this.http.get<GoodsServiceGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/goods-services/${goodsId}`);
	}

	create(worldId: string, request: UpsertGoodsServiceRequest): Observable<GoodsServiceGetResponse> {
		return this.http.post<GoodsServiceGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/goods-services`, {
			Name: request.name,
			Category: request.category ?? null,
			Description: request.description ?? null,
			GmNotes: request.gmNotes ?? null,
			Cost: request.cost ?? null,
			Currency: request.currency ?? null,
			Availability: request.availability ?? null,
			ImageAssetId: request.imageAssetId ?? null,
			SourcePoiId: request.sourcePoiId ?? null,
			FoundryId: request.foundryId ?? null,
		});
	}

	update(worldId: string, goodsId: string, request: UpsertGoodsServiceRequest): Observable<GoodsServiceGetResponse> {
		return this.http.put<GoodsServiceGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/goods-services/${goodsId}`, {
			Name: request.name,
			Category: request.category ?? null,
			Description: request.description ?? null,
			GmNotes: request.gmNotes ?? null,
			Cost: request.cost ?? null,
			Currency: request.currency ?? null,
			Availability: request.availability ?? null,
			ImageAssetId: request.imageAssetId ?? null,
			SourcePoiId: request.sourcePoiId ?? null,
			FoundryId: request.foundryId ?? null,
		});
	}

	delete(worldId: string, goodsId: string): Observable<void> {
		return this.http.delete<void>(`${environment.api.baseUrl}/v1/worlds/${worldId}/goods-services/${goodsId}`);
	}
}
